import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'

interface HeaderCellProps {
  columnType: string
  children?: ReactNode
}

type StyledHeaderCellProps = Pick<HeaderCellProps, 'columnType'>

const StyledHeaderCell = styled.div<StyledHeaderCellProps>`
  ${({
    theme: {
      colors: {
        grey: { grey_80 },
      },
      fonts: { sourceSansPro },
    },
    columnType,
  }) => {
    return css`
      font-family: ${sourceSansPro};
      font-size: 15px;
      line-height: 1.2;
      font-weight: normal;
      color: ${grey_80};
      text-transform: uppercase;
      padding: 6px 0 6px 0;
      text-align: ${columnType === 'team' ? 'left' : 'right'};

      ${mobileCSS(css`
        font-size: 12px;
      `)}
    `
  }}
`

const HeaderCell: FunctionComponent<HeaderCellProps> = ({
  columnType,
  children,
}) => {
  return <StyledHeaderCell columnType={columnType}>{children}</StyledHeaderCell>
}

export default HeaderCell
